const grid = () => {
  const parent = document.querySelector('.js-grid');

  const resizeAllMasonryItems = () => {
    const container = document.querySelector('.js-grid');
    let height = 0;
    let tempHeight = 0;
    const firstColumn = document.querySelectorAll(
      '.c-post-filter__item:nth-child(3n+1)',
    );
    firstColumn.forEach(item => {
      tempHeight += item.getBoundingClientRect().height + 50;
    });
    height = tempHeight;

    tempHeight = 0;
    const secondColumn = document.querySelectorAll(
      '.c-post-filter__item:nth-child(3n+2)',
    );
    secondColumn.forEach(item => {
      tempHeight += item.getBoundingClientRect().height + 50;
    });
    if (tempHeight > height) height = tempHeight;

    tempHeight = 0;
    const thirdColumn = document.querySelectorAll(
      '.c-post-filter__item:nth-child(3n)',
    );
    thirdColumn.forEach(item => {
      tempHeight += item.getBoundingClientRect().height + 50;
    });
    if (tempHeight > height) height = tempHeight;
    container.style.height = `${height}px`;
  };

  document.resizeAllMasonryItems = resizeAllMasonryItems;

  if (parent && window.matchMedia('(min-width: 768px)').matches) {
    resizeAllMasonryItems();
    window.addEventListener(
      'resize',
      () => {
        resizeAllMasonryItems();
      },
      true,
    );
  }
};

export default grid;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/grid.js